<template>
	<div class="container">
		<h2 class="text-darkestRed text-lg">Wichtig!</h2>
		<div class="grid grid-cols-1 gap-6 md:grid-cols-3">
			<div>
				<h2 class="mt-0 text-3xl tracking-wide break-all md:text-5xl">
					Mitteilung
				</h2>
			</div>
			<!-- <div class="text-balance">
				Die Propeller-Open Stage ist eure Möglichkeit als Band, Singer- oder
				Songwriter auf einer großen Bühne professionell abgemischt zu werden und
				für 20 Minuten die Crowd zum Tanzen und Springen zu bringen und dabei
				selber ABZUHEBEN. Weitere Infos und Anmeldung hier.
				<br />
				<div class="mt-3 flex items-center gap-1">
					<UIcon name="i-heroicons-chevron-double-right" class="size-3" />
					<NuxtLink to="/ticket" @click="toOpenStage">
						Als Band bewerben
					</NuxtLink>
					<UIcon name="i-heroicons-chevron-double-left" class="size-3" />
				</div>
			</div> -->
			<div class="md:col-span-2">
				<h3 class="mt-0">Das Propellerfestival findet 2026 nicht mehr statt</h3>
				<p class="text-balance">
					Nach vier ereignisreichen Jahren mit vielen neuen Erfahrungen und
					inspirierenden Momenten hat das Team des Propellerfestivals das
					vorläufige Ende des Festivals beschlossen.
					<br />
					Die Entscheidung wurde nach intensiver Beratung und gründlicher
					Analyse der vergangenen Veranstaltungen getroffen. Ausschlaggebend
					waren vor allem die hohen Ausgaben im Verhältnis zur Teilnehmendenzahl
					sowie eine veränderte Schwerpunktsetzung auf andere Themen der Kinder-
					und Jugendarbeit. Trotz großer Anstrengungen und erheblichem
					personellen Einsatz gelang es in den letzten Jahren nur bedingt, die
					Zahl der Teilnehmenden zu erhöhen oder eine breitere Unterstützung
					durch außerkirchliche Verbände zu gewinnen.
					<br />
					„Das Propellerfestival war ein inspirierendes Projekt, das viele
					Menschen miteinander verbunden und bereichert hat“, betont das
					Organisationsteam. „Wir blicken dankbar auf das Geleistete zurück und
					sind überzeugt, dass der Geist des Festivals in anderer Form
					weiterwirken wird.“
				</p>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
async function toOpenStage() {
	await navigateTo('/openstage')
}
</script>
